import {
  collection,
  getCountFromServer,
  query,
  where
} from "firebase/firestore";
import { getSummaryCount } from "./api";
import { database } from "./firebase";

export async function getComplaintsSummaryCount(filters, accessToken) {
  const complaintsRef = collection(database, "complaints");

  if (!filters || filters.length === 0) {
    const snapshot = await getCountFromServer(complaintsRef);
    return snapshot.data().count;
  }

  let baseQuery = query(complaintsRef);
  const inequalityFilters = [];
  let inequalityFilterFields = [];

  filters.forEach((value, index) => {
    if ((index + 1) % 3 === 0 && index !== 0) {
      const field = filters[index - 2];
      const operator = filters[index - 1];

      if (["<", "<=", ">", ">=", "!="].includes(operator)) {
        inequalityFilters.push(field, operator, value);
        inequalityFilterFields = [...new Set([...inequalityFilterFields, field])];
      } else {
        baseQuery = query(baseQuery, where(field, operator, value));
      }
    }
  });

  if (inequalityFilterFields.length <= 1) {
    inequalityFilters.forEach((value, index) => {
      if ((index + 1) % 3 === 0 && index !== 0) {
        const field = inequalityFilters[index - 2];
        const operator = inequalityFilters[index - 1];
        baseQuery = query(baseQuery, where(field, operator, value));
      }
    });

    const snapshot = await getCountFromServer(baseQuery);
    return snapshot.data().count;
  } else {
    const response = await getSummaryCount({
      accessToken,
      type: "count",
      collection: "complaints",
      query: { data: filters }
    });
    return response;
  }
}
